import React, { useEffect, useState } from "react";
import Button from "../button/Button";
import Modal from "../modal";
import { ReactComponent as MusicIcon } from "../../assets/icons/music.svg";
import { styled } from "styled-components";
import axios from "axios";

const TriggerButton = styled.button`
    color: #ffffff;
    font-size: 20px;
    background-color: transparent !important;
    background-image: none;
    cursor: pointer;
    font-family: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: 0 !important;
    color: inherit;
    margin: 0;
    padding: 0;
    border: none !important;
    box-sizing: border-box;
    border-width: 0;
    transition: 100ms;
    &:hover {
        transform: scale(1.1);
        background-color: transparent !important;
    }
`;

const H2 = styled.h2`
    text-align: center;
    margin-bottom: 20px;
    font-family: "Red Hat Display";
    font-size: 28px!important;
    text-transform: uppercase;
`;

const GenreContainer = styled.div`
    overflow-y: auto;
    max-height: 50vh;
    @media (min-with: 1280px) {
        display: flex;
        flex-wrap: wrap;
        // column-gap: 8px;
    }
`;
const GenreWrapper = styled.div`
    display: inline-block;
    margin-bottom: 8px;
    margin-right: 8px;
`;

const GenrePopUp = ({ apiEndpoint, dateBaseURL }) => {
    const [isOpen, setIsOpen] = useState(false);

    const [genreList, setGenreList] = useState([]);

    useEffect(async () => {
        await getGenreList();
    }, []);

    const getGenreList = async () => {
        try {
            const res = await axios.get(apiEndpoint);
            
            setGenreList(res.data.data)
        } catch (error) {
            
        }
    };

    return (
        <>
            <TriggerButton
                type="button"
                onClick={() => setIsOpen(true)}>
                <MusicIcon
                    fill="#fff"
                    height="20px"
                    width="20px"
                />
            </TriggerButton>
            <Modal
                open={isOpen}
                onClose={() => setIsOpen(false)}>
                <H2>Find the artists that suit your music</H2>
                <GenreContainer>
                    {genreList.map((val, index) => (
                        <GenreWrapper>
                            <Button
                                variant="rounded"
                                key={val["genre_id"]}
                                as="a"
                                href={`${dateBaseURL}?genre=${val["genre_id"]}`}>
                                {val["genre_name"]}
                            </Button>
                        </GenreWrapper>
                    ))}
                </GenreContainer>
            </Modal>
        </>
    );
};

export default GenrePopUp;
